export default {
  name: 'project-card',
  components: {},
  props: {
    project: Object,
    featured: Boolean
  },
  data() {
    return {

    }
  },
  computed: {

  },
  mounted() {

  },
  methods: {

  }
}